export default {
    items: [
        {
            name: "Inicio",
            url: "/inicio",
            icon: "icon-home",
            permisos: ["inicio"],
        },
        {
            name: "Panel de control",
            url: "/panel-de-control",
            icon: "fa fa-pie-chart fa-lg",
            permisos: ["superadmin", "modulo-panel-control-graficas"],
        },
        {
            name: "Mi empresa",
            url: `/my-company/:id`,
            icon: "fa fa-building-o",
            permisos: ["empresa-ver-generales"],
        },
        {
            name: "Empresas",
            url: "/empresas",
            icon: "icon-user",
            permisos: ["modulo-empresas"],
        },
        {
            name: "Fabricantes",
            url: "/fabricantes",
            icon: "fa fa-industry",
            permisos: ["modulo-fabricantes"],
        },
        {
            name: "Proveedores",
            url: "/providers",
            icon: "fa fa-handshake-o",
            permisos: ["modulo-fabricantes"],
        },
        {
            name: "CAS",
            url: "/cas",
            icon: "el-icon-notebook-2",
            permisos: ["modulo-cas"],
            children: [
                {
                    name: "Peligros",
                    url: "/cas/parametrizacion",
                    icon: "el-icon-s-order",
                    permisos: ["modulo-cas-parametrizacion"],
                },
                {
                    name: "Componentes",
                    url: "/cas/componentes",
                    icon: "el-icon-cpu",
                    permisos: ["modulo-cas-componentes"],
                },
                /* {
                    name: "Crear",
                    url: "/cas/crear",
                    icon: "fa fa-floppy-o",
                    permisos: ["modulo-cas-crear"],
                }, */
                {
                    name: "Familias",
                    url: "/cas/familias",
                    icon: "fa fa-users",
                    permisos: [ 'superadmin','admin','modulo-familia-cas'],
                },
            ],
        },
        {
            name: "Tickets",
            url: "/tickets",
            icon: "icon-user",
            permisos: ["modulo-tickets"],
        },
        {
            name: "Productos",
            url: "/buscador-productos",
            icon: "icon-layers",
            permisos: ["modulo-productos"],
        },
        {
            name: "Decreto-1630",
            url: "/decreto-1630",
            icon: "icon-layers",
            permisos: ["modulo-decreto-1630"],
            children: [
                {
                    name: "Productos",
                    url: "/decreto-1630/productos",
                    icon: "icon-layers",
                    permisos: ["modulo-decreto-1630"],
                },
                {
                    name: "Componentes",
                    url: "/decreto-1630/componentes",
                    icon: "icon-layers",
                    permisos: ["modulo-decreto-1630"],
                },
            ],
        },
        {
            name: "Productos proveedores",
            url: "/productos-proveedores",
            icon: "icon-layers",
            permisos: ["productos-proveedores"],
        },
        {
            name: "Videos",
            url: "/videos",
            icon: "fa fa-file-video-o",
            permisos: ["modulo-admin-video", "superadmin"],
            children: [
                {
                    name: "Administración",
                    url: "/videos/administracion",
                    icon: "fa fa-file-video-o",
                    permisos: ["modulo-admin-video", "superadmin"],
                },
                {
                    name: "Categorias",
                    url: "/videos/categorias",
                    icon: "fa fa-file-video-o",
                    permisos: ["modulo-admin-video", "superadmin"],
                },
            ],
        },
        {
            name: "Videos",
            url: "/videos/empresa",
            icon: "fa fa-file-video-o",
            permisos: ["modulo-empresa-video"],
        },
        {
            name: "Banners",
            url: "/banners",
            icon: "fa fa-image",
            permisos: ["modulo-banners"],
            children: [
                {
                    name: "Banners de empresas",
                    url: "/banners",
                    icon: "fa fa-image",
                    permisos: ["modulo-banners"],
                },
                {
                    name: "Banners del sistema",
                    url: "/app-banners",
                    icon: "fa fa-image",
                    permisos: ["modulo-banners-app"],
                },
            ],
        },
        {
            name: "Trabajadores",
            url: "/trabajadores/trabajadores",
            icon: "fa fa-users",
            permisos: ["modulo-trabajadores"],
        },
        {
            name: "Análisis de riesgos",
            url: "/analisis-de-riesgos",
            icon: "icon-layers",
            permisos: ["modulo-analisis-riesgos"],
            children: [
                {
                    name: "Tareas",
                    url: "/analisis-de-riesgos/tareas",
                    icon: "fa fa-clone",
                    permisos: ["modulo-analisis-riesgos-tareas"],
                },
                {
                    name: "Análisis",
                    url: "/analisis-de-riesgos/analisis",
                    icon: "icon-speech",
                    permisos: ["modulo-analisis-riesgos-analisis"],
                },
                {
                    name: "Fichas de control",
                    url: "/analisis-de-riesgos/fichas-de-control",
                    icon: "fa fa-list-ol",
                    permisos: ["modulo-analisis-riesgos-fichas-de-control"],
                },
                {
                    name: "Configuraciones",
                    url: "/analisis-de-riesgos/configuraciones-generales",
                    icon: "fa fa-cogs",
                    permisos: ["analisis-riesgos-configuraciones-concepto"],
                },
            ],
        },
        {
            name: "Identificación de peligros",
            url: "/identificacion-de-peligros",
            icon: "icon-layers",
            permisos: ["identificacion-de-peligros-matriz-ram"],
            children: [
                {
                    name: "Matriz RAM",
                    url: "/identificacion-de-peligros/matriz-ram",
                    icon: "fa fa-search",
                    permisos: ["identificacion-de-peligros-matriz-ram"],
                },
                {
                    name: "Matriz HAZID",
                    url: "/identificacion-de-peligros/matriz-hazid",
                    icon: "fa fa-table",
                    permisos: ["identificacion-de-peligros-matriz-ram"],
                },
            ],
        },
        {
            name: "Calculadora",
            url: "/calculadora",
            icon: "fa fa-calculator",
            permisos: ["calculadora"],
            children: [
                {
                    name: "6ª edición",
                    url: "/calculadora/productos",
                    icon: "icon-layers",
                    permisos: ["calculadora"],
                },
            ],
        },
        {
            name: "Diseñe  Sus  Etiquetas",
            url: "/productos_et",
            icon: "icon-layers",
            permisos: [],
            children: [
                {
                    name: "Ordenes",
                    url: "/ordenes-empresas",
                    icon: "icon-speech",
                    permisos: ["visualizar-ordenes-disene-etiquetas"],
                },
                {
                    name: "Buscar Productos",
                    url: "/buscador-productos-et",
                    icon: "icon-speech",
                    permisos: [
                        "visualizar-buscador-productos-disene-etiquetas",
                    ],
                },
            ],
        },
        {
            name: "Diseño de listas de chequeo",
            icon: "icon-book-open",
            permisos: [],
            children: [
                {
                    name: "Tipos de seguimiento",
                    url: "/tipo-seguimiento",
                    icon: "cui-options",
                    permisos: [
                        "modulo-diseno-listas-chequeo-tipos-seguimiento",
                    ],
                },

                {
                    name: "Items",
                    url: "/items",
                    icon: "cui-options",
                    permisos: ["modulo-diseno-listas-chequeo-items"],
                },
                {
                    name: "Tipos de listas de chequeo",
                    url: "/tipo-lista-chequeo",
                    icon: "cui-options",
                    permisos: [
                        "modulo-diseno-listas-chequeo-tipos-listas-chequeo",
                    ],
                },
            ],
        },
        {
            name: "Preinspecciones",
            url: "/planeacion-auditoria",
            icon: "icon-list",
            permisos: ["modulo-preinspecciones-hallazgos"],
        },
        {
            name: "Inspecciones",
            url: "/listas-chequeo",
            icon: "cui-options",
            permisos: ["modulo-inspecciones-hallazgos"],
        },
        {
            name: "Seguimiento",
            url: "/seguimiento-general",
            icon: "icon-book-open",
            permisos: ["modulo-seguimiento-general"],
        },
        {
            name: "Reportes",
            url: "/reportes",
            icon: "icon-layers",
            permisos: [],
            children: [
                /* {
                    name: 'Registro de Productos Químicos',
                    url: '/reportes/inventario',
                    icon: 'icon-speech',
                    permisos: [
                        'modulo-inventario-productos',
                    ]
                }, */
                {
                    name: "Registro de Accesos",
                    url: "/reportes/registro-accesos",
                    icon: "icon-speech",
                    permisos: ["superadmin"],
                },
                {
                    name: "Tiempo de conexión",
                    url: "/reportes/tiempo-de-conexion",
                    icon: "fa fa-clock-o fa-lg",
                    permisos: ["superadmin"],
                },
                {
                    name: "Licencias",
                    url: "/reportes/licencias",
                    icon: "fa fa-check-circle-o",
                    permisos: ["modulo-reporte-licencias"],
                },
                {
                    name: "Señalización de tanques",
                    url: "/reports/signaling-of-tanks",
                    icon: "fa fa-tasks",
                    permisos: ["reporte-modulo-tanques"],
                },
            ],
        },
        {
            name: "Documentos",
            url: "/documentos",
            icon: "icon-layers",
            permisos: ["modulo-documentos"],
        },
        {
            name: "Almacenamiento de productos químicos",
            icon: "icon-puzzle",
            permisos: [],
            children: [
                {
                    icon: "icon-puzzle",
                    name: "Almacenamiento ingenieros",
                    url: "/matriz-compatibilidad/almacenamiento-ingenieros",
                    permisos: [
                        "modulo-matriz-compatibilidad-almacenamiento-ingenieros",
                    ],
                },
                {
                    icon: "fa fa-car",
                    name: "Transporte",
                    url: "/matriz-compatibilidad/transporte",
                    permisos: ["modulo-matriz-compatibilidad-transporte"],
                },
                {
                    icon: "fa fa-archive",
                    name: "Diseño de matriz de compatibilidad",
                    url: "/matriz-compatibilidad/almacenamiento",
                    permisos: ["modulo-matriz-compatibilidad-almacenamiento"],
                },
                {
                    name: "Auditar matriz de compatibilidad",
                    url: "/matriz-compatibilidad/approve",
                    icon: "fa fa-check-circle-o",
                    permisos: ["modulo-matriz-compatibilidad-auditar"],
                },
                {
                    name: "Administrador",
                    url: "/matriz-compatibilidad/administracion",
                    icon: "icon-puzzle",
                    permisos: ["modulo-matriz-compatibilidad-administrador"],
                },
            ],
        },
        {
            name: "FDS",
            icon: "el-icon-notebook-2",
            permisos: ["menu-fds"],
            children: [
                {
                    icon: "el-icon-setting",
                    name: "Administrador de datos",
                    url: "/fds/administrador/datos",
                    permisos: "fds-admin-datos",
                },
                {
                    icon: "el-icon-document",
                    name: "Diseño FDS",
                    url: "/fds/listar",
                    permisos: "fds-diseno-fds",
                },
            ],
        },
        {
            name: "Inventario",
            url: "/inventory",
            icon: "fa fa-star",
            permisos: ["modulo-inventario"],
            children: [
                {
                    name: "Configuración",
                    url: "/inventory/sections",
                    icon: "fa fa-cog",
                    permisos: ["configuracion-inventario"],
                },
                {
                    name: "Generar reporte",
                    url: "/generate-report-inventory",
                    icon: "fa fa-file-excel-o",
                    permisos: [
                        "generar-reporte-inventario",
                        "generar-reporte-inventario-contratistas",
                    ],
                },
            ],
        },
        {
            name: "Accidentes mayores",
            url: "/high-accident",
            icon: "fa fa-exclamation-triangle",
            permisos: ["modulo-accidentes-mayores"],
            children: [
                {
                    name: "Gestión",
                    url: "/high-accidents",
                    icon: "fa fa-flask",
                    permisos: ["modulo-accidentes-mayores"],
                },
                {
                    name: "Configuración",
                    url: "/high-accidents-admin",
                    icon: "fa fa-cog",
                    permisos: ["modulo-administrador-accidentes-mayores"],
                },
            ],
        },
        {
            name: "Seguridad de procesos",
            url: "/seguridad-de-procesos",
            icon: "icon-layers",
            permisos: ["superadmin", "administracion-procesos-seguridad"],
            children: [
                {
                    name: "Sistema de Gestión PPAM",
                    url: "/seguridad-de-procesos/sistema-de-gestion-pepam",
                    icon: "el-icon-notebook-2",
                    permisos: ["administracion-procesos-seguridad"],
                },
                {
                    name: "Cumplimiento general",
                    url: "/seguridad-de-procesos/cumplimiento-general",
                    icon: "fa fa-percent",
                    permisos: ["administracion-procesos-seguridad"],
                },
                {
                    name: "Parámetros",
                    url: "/seguridad-de-procesos/parametros",
                    icon: "fa fa-cog",
                    permisos: ["administracion-procesos-seguridad"],
                },
                {
                    name: "Configuración de estudios",
                    url: "/findings-config",
                    icon: "fa fa-cog",
                    permisos: ["modulo-configuracion-de-hallazgos"],
                },
                {
                    name: "Gestión de estudios",
                    url: "/findings",
                    icon: "fa fa-flask",
                    permisos: ["ver-modulo-reporte-hallazgos"],
                },
            ],
        },
        {
            name: "Histórico",
            url: "/history",
            icon: "fa fa-history",
            permisos: ["superadmin", "modulo-historico"],
            children: [
                {
                    name: "Actualizaciones PQ",
                    url: "/history/update-pq",
                    icon: "el-icon-notebook-2",
                    permisos: [
                        "superadmin",
                        "modulo-historico-actualizacion-pq",
                    ],
                },
                {
                    name: "Asignaciones PQ",
                    url: "/history/assign-pq",
                    icon: "fa fa-tasks",
                    permisos: ["superadmin", "modulo-historico-asignacion-pq"],
                },
            ],
        },
        {
            name: "SGA",
            url: "/sga",
            icon: "fa fa-list-alt",
            permisos: ["superadmin", "modulo-sga"],
            children: [
                {
                    name: "Configuración",
                    url: "/sga/configs",
                    icon: "el-icon-notebook-2",
                    permisos: ["superadmin", "modulo-sga-configuraciones"],
                },
            ],
        },
        {
            name: "Administracion",
            url: "/administracion",
            icon: "icon-layers",
            permisos: ["superadmin"],
            children: [
                {
                    name: "General",
                    url: "/administracion",
                    icon: "el-icon-notebook-2",
                    permisos: ["superadmin"],
                },
                {
                    name: "Formularios",
                    url: "/form-builder",
                    icon: "fa fa-book",
                    permisos: ["modulo-formularios"],
                },
            ],
        },
        {
            name: "Cerrar Sesión",
            url: "/logout",
            icon: "cui-account-logout",
            permisos: ["inicio"],
        }/* ,
        {
            name: "Dashboard",
            url: "/dashboard",
            icon: "icon-speedometer",
            permisos: ["superadmin"],
        }, */
    ],
};
